import { Action } from '../../actions';
import { FILTER_INTERNAL_MARKETERS } from '../../actions/marketers/internal/filterInternalMarketers';
import { LOAD_INTERNAL_MARKETERS } from '../../actions/marketers/internal/loadInternalMarketers';
import { SORT_INTERNAL_MARKETERS } from '../../actions/marketers/internal/sortInternalMarketers';
import { UPDATE_INTERNAL_MARKETERS } from '../../actions/marketers/internal/updateInternalMarketers';
import { UPDATE_INTERNAL_MARKETERS_FILTER_PARAMS } from '../../actions/marketers/internal/updateInternalMarketersFilterParams';
import { UPDATE_INTERNAL_MARKETERS_PAGE_STATUS } from '../../actions/marketers/internal/updateInternalMarketersPageStatus';
import { MarketersPageStates, MarketersState } from '../../typings/marketers';

import { filterInternalMarketers } from './internal/filterInternalMarketers';
import { loadInternalMarketers } from './internal/loadInternalMarketers';
import { sortInternalMarketers } from './internal/sortInternalMarketers';
import { updateInternalMarketers } from './internal/updateInternalMarketers';
import { updateInternalMarketersFilterParams } from './internal/updateInternalMarketersFilterParams';
import { updateInternalMarketersPageStatus } from './internal/updateInternalMarketersPageStatus';

export const getMarketersInitialState = (): MarketersState => ({
    marketers: [],
    pageStatus: MarketersPageStates.PENDING,
    allMarketers: [],
    filter: {
        products: []
    }
});

export function internalMarketers(state: MarketersState = getMarketersInitialState(), action: Action): MarketersState {
    switch (action.type) {
        case LOAD_INTERNAL_MARKETERS:
            return loadInternalMarketers(state, action);

        case UPDATE_INTERNAL_MARKETERS:
            return updateInternalMarketers(state, action);

        case FILTER_INTERNAL_MARKETERS:
            return filterInternalMarketers(state, action);

        case UPDATE_INTERNAL_MARKETERS_PAGE_STATUS:
            return updateInternalMarketersPageStatus(state, action);

        case UPDATE_INTERNAL_MARKETERS_FILTER_PARAMS:
            return updateInternalMarketersFilterParams(state, action);

        case SORT_INTERNAL_MARKETERS:
            return sortInternalMarketers(state, action);

        default:
            return state;
    }
}
